module.exports = __webpack_public_path__ + "static/media/dumbell.abb1743e.svg";